<template>
  <div class="banks-response-time p-3">
    <h4>How long it takes banks to file a suspicious activity report</h4>
    <p class="mb-0">The median number of days it took the top five banks by transactions amount in FinCEN Files to file a report from the time transactions took place and the time it was reported to FinCEN.</p>
    <stacked-bar-chart :data="data" x-axis-tick-format=",.0f" label-above hide-legend :social-mode="socialMode" :fixed-height="height" />
    <p class="text-muted mt-2 small text-right">Source: FinCEN Files data</p>
    <p class="mt-2 font-italic">This data is not representative of all SARs received by the U.S. Department of Treasury's Financial Crimes Enforcement Network. It is based on 1,750 reports in the FinCEN Files data.</p>
  </div>
</template>

<script>
import chart from '../mixins/chart'

export default {
  name: 'BanksResponseTime',
  mixins: [chart],
  data () {
    return {
      data: [
        { label: 'Barclays', value: 1205.0 },
        { label: 'JPMorgan', value: 519.0 },
        { label: 'Standard Chartered', value: 426.0 },
        { label: 'Bank of New York Mellon', value: 210.0 },
        { label: 'Deutsche Bank', value: 135.5 }
      ]
    }
  }
}
</script>
